import { ZodiacPiscesIcon } from './ZodiacPiscesIcon';

/**
 * author: Michael Richins
 * id 3410C5F7-CAEF-405C-9159-86F38ACE9619
 * name zodiac-pisces
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-pisces.svg
 * tags
 */
export const HoroscopePiscesIcon = ZodiacPiscesIcon;
export default HoroscopePiscesIcon